import { render, staticRenderFns } from "./turkmanairaktarim.vue?vue&type=template&id=696dbd12&"
import script from "./turkmanairaktarim.vue?vue&type=script&lang=js&"
export * from "./turkmanairaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports